import { forwardRef, type MouseEventHandler } from "react";

import { Icon_TriangleDown } from "@shapr3d/frontend-lib";

import useTranslation from "../../../../hooks/useTranslation";
import { Avatar } from "../../../Comment/Avatar";

import style from "./AccountButton.module.css";

type AccountButtonProps = {
  name?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  isCompact?: boolean;
};

export const AccountButton = forwardRef<HTMLDivElement, AccountButtonProps>(
  ({ name, onClick, isCompact }, ref) => {
    const { t, m } = useTranslation();
    const unknownUser = t(m.General.UnknownUser);
    return (
      <div ref={ref} className={style.emailAvatarContainer} onClick={onClick}>
        <Avatar title={name ?? unknownUser} />
        {!isCompact && (
          <div className={style.emailContainer}>
            <span className={style.email}>{name ?? unknownUser}</span>
            <Icon_TriangleDown />
          </div>
        )}
      </div>
    );
  }
);
AccountButton.displayName = "AccountButton";
